export const MY_HOW_KEY = "my_how";

export const loadHOW = () => localStorage.getItem(MY_HOW_KEY);
export const setHOW = (name) => !!name && localStorage.setItem(MY_HOW_KEY, name);
export const clearWHO = (name) => localStorage.removeItem(MY_HOW_KEY);